import { PaymentMethodResponseDto } from 'app/API';

export const getPaymentMethodSummary = (paymentMethods: Pick<PaymentMethodResponseDto, 'default' | 'last4'>[]) => {
  const defaultPaymentMethod = paymentMethods.find((paymentMethod) => paymentMethod.default);

  if (!defaultPaymentMethod) {
    return 'No payment method on file';
  }

  return `Card **** **** **** ${defaultPaymentMethod.last4}`;
};
